import { type ReactElement, useMemo } from "react";
import { Typography } from "../../abstract/Typography/Typography";
import { TypographyProps } from "../../abstract/Typography/Typography.types.ts";
import { compiler } from "markdown-to-jsx";

export type A5TextProps = TypographyProps;

export function A5Text({
  variant = "body-l",
  children,
  ...restProps
}: A5TextProps): ReactElement {
  const transformerText = useMemo(
    () =>
      typeof children === "string"
        ? compiler(children, { forceInline: true, wrapper: null })
        : children,
    [children],
  );
  return (
    <Typography variant={variant} children={transformerText} {...restProps} />
  );
}
